import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrderService } from '../../services/order.service';
import { QuoteOrderLinePlannedLoad, SearchTagType } from '../../models/models';

@Component({
    selector: 'order-planned-card',
    templateUrl: './order-planned-card.component.html',
    standalone: false
})
export class OrderPlannedCard implements OnInit {
    @Input() loads: QuoteOrderLinePlannedLoad[] = [];
    @Input() loadStatus: string = '';
    @Input() isVisible: boolean = true;
    //@Input() colSize: number = 2;
    @Input() cardSize: number = 12;
    @Output() onClick = new EventEmitter<any>();

    public tagTypeList: SearchTagType[] = [];

    constructor(private orderService: OrderService) {}

    ngOnInit() {
        this.orderService.getSearchTagTypes().subscribe(result => {
            this.tagTypeList = result.resultCollection;
        });
        this.loads = this.loads.sort((left, right): number => {
            // Sort Descending first by OrderEventDate (if not null) then by FirstPickupDate
            if ((left.orderEventDate == null ? left.firstPickupDate! : left.orderEventDate!) > (right.orderEventDate == null ? right.firstPickupDate! : right.orderEventDate!)) return -1;
            if ((left.orderEventDate == null ? left.firstPickupDate! : left.orderEventDate!) < (right.orderEventDate == null ? right.firstPickupDate! : right.orderEventDate!)) return 1;
            return 0;
        });
    }

    public loadClick(load: QuoteOrderLinePlannedLoad) {
        this.onClick.emit(load);
        //console.log(load);
    }

    public getTagTypes(idList: string) {
        var tagTypes: SearchTagType[] = [];
        if (idList && idList != "") {
            var arr: number[] = [];
            arr = idList.replace(/, +/g, ",").split(",").map(Number);
            for (var i = 0; i < arr.length; i++) {
                var idx: number = this.tagTypeList.findIndex(t => t.tagTypeID == arr[i]);
                if (idx >= 0) {
                    tagTypes.push(this.tagTypeList[idx]);
                }
            }
        }
        return tagTypes;
    }

    public getCardClass(load: QuoteOrderLinePlannedLoad) {
        const isHighPriority = (load.loadPriorityAbbreviation == "High");
        const isExpedite = (load.rateIndex == "Expedite");
        const isCG = (load.erpAssignedTo == "CG" || load.quoteOrderLineType == "CG");
        const isRFQP = (load.quoteOrderLineType == "RFQP");
        if (isExpedite) {
            return "expedite";
        }
        else if (isHighPriority) {
            return "highPriority";
        }
        else if (isCG) {
            return "warning";
        }
        else if (isRFQP) {
            return "warning";
        }
        else {
            return "";
        }
    }
}
